import { useEffect } from "react";

import {
    ConfluenceTemplateDetailsRelayPageTemplate,
    ConfluenceTemplateDetailsRelayPageTemplateProps
} from "@/templates/software/confluence/templates/confluence-templates-page/src/relay/confluence-template-details-relay-page.template";
import { checkFeatureFlagGate, featureFlags } from "@/utils/feature-flags";

export const ConfluenceTemplateDetailsRelayPage = ({
    queryRef
}: ConfluenceTemplateDetailsRelayPageTemplateProps) => {
    useEffect(() => {
        checkFeatureFlagGate(featureFlags.cpapiwdConfluenceTemplateDetails);
    }, []);

    return <ConfluenceTemplateDetailsRelayPageTemplate queryRef={queryRef} />;
};
